import type { AgencyListTab } from '@saaga/shared/interfaces/agencies.interface'
import { BuildingIcon, FileEditIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { AgenciesEmptyState } from '@/components/agencies/agencies-empty-state.molecule'

interface AgenciesEmptyStateViewProps {
  activeTab: AgencyListTab
  onCreateAgency: () => void
}

export const AgenciesEmptyStateView = ({
  activeTab,
  onCreateAgency,
}: AgenciesEmptyStateViewProps): ReactNode => {
  if (activeTab === 'studio') {
    return (
      <AgenciesEmptyState
        title="No studio agencies"
        description="You have no agencies in your studio. Create your first agency to get started with custom AI assistants for your organization."
        icon={FileEditIcon}
        actionLabel="Create your own agency"
        onAction={onCreateAgency}
      />
    )
  }

  if (activeTab === 'organization') {
    return (
      <AgenciesEmptyState
        title="No organization agencies"
        description="No agencies have been published to your organization yet. Create a draft and publish it to make it available to your team."
        icon={BuildingIcon}
      />
    )
  }

  return (
    <AgenciesEmptyState
      title="No agencies available"
      description="There are no agencies in the marketplace at the moment. Check back later for new agencies."
    />
  )
}
